<div class="container-fluid-modal">

  <form class="form-inline required" #cat="ngForm" (ngSubmit)="cat.form.valid && submitForm(cat.value)" novalidate>
    <div class="add" *ngIf="!editData">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Add Products</h4>
        <div class="headerButton">
          <button type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</button>
          <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i class="fa fa-times"
                                                                                            aria-hidden="true"></i>
            Cancel
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group col-lg-12">
                  <label for="Body Part" class="labelRequired">Body Part </label>
                  <select id="mySelect" data-show-content="true" class="form-control" placeholder="Body Part"
                          [(ngModel)]="model.body_part_id" name="body_part_id" (change)="bodypartChange($event)"
                          required #body_part_id="ngModel"
                          [ngClass]="{'has-danger': cat?.submitted  && body_part_id?.invalid }">
                    <option disabled>Select Body Part</option>
                    <option *ngFor="let data of bodypartsData" [value]="data?.id">
                      {{data?.name}}
                    </option>
                  </select>
                  <div *ngIf="cat?.submitted  && body_part_id?.invalid">
                    <div [hidden]="!body_part_id.errors.required" class="formError"> * Body Part is required
                    </div>
                  </div>
                </div>
                <div class="form-group col-lg-12">
                  <label for="Implant" class="labelRequired">Implant </label>
                  <select id="mySelect" data-show-content="true" class="form-control" placeholder="Implant"
                          [(ngModel)]="model.implant_id" name="implant_id" (change)="implantChange($event)" required
                          #implant_id="ngModel" [ngClass]="{'has-danger' : cat?.submitted  && implant_id?.invalid }">
                    <option disabled>Select Implant</option>
                    <option *ngFor="let data of implantsSelect" [value]="data?.id">
                      {{data?.name}}
                    </option>
                  </select>
                  <div *ngIf="cat?.submitted && implant_id?.invalid">
                    <div [hidden]="!implant_id.errors.required" class="formError"> * Implant is required</div>
                  </div>
                </div>
                <div class="form-group col-lg-12">
                  <label for="Product Category" class="labelRequired">Product Category </label>
                  <select id="mySelect" data-show-content="true" class="form-control" placeholder="Product Category"
                          [(ngModel)]="model.product_category_id" name="product_category_id" required
                          #product_category_id="ngModel"
                          [ngClass]="{'has-danger': cat?.submitted  && product_category_id?.invalid }">
                    <option disabled>Select Product Category</option>
                    <option *ngFor="let data of productCategoryData" [value]="data?.id">
                      {{data?.name}}
                    </option>
                  </select>
                  <div *ngIf="cat?.submitted  && product_category_id?.invalid">
                    <div [hidden]="!product_category_id.errors.required" class="formError"> * Product Category is
                      required
                    </div>
                  </div>
                </div>
                <div class="form-group col-lg-12">
                  <label for="Name" class="labelRequired">Name </label>
                  <input type="text" placeholder="Name" class="form-control" name="name" #name="ngModel"
                         [(ngModel)]="user.name" required [ngClass]="{'has-danger': cat?.submitted  && name?.invalid }">
                  <div *ngIf="cat?.submitted  && name?.invalid ">
                    <div [hidden]="!name.errors.required" class="formError"> * Product Name is required</div>
                  </div>

                </div>
                <div class="form-group col-lg-12">
                  <label for="Code" class="labelRequired">Code </label>
                  <input type="text" placeholder="Code" class="form-control" name="code" #code="ngModel" ngModel
                         required [ngClass]="{'has-danger':cat?.submitted && code?.invalid }">
                  <div *ngIf="cat?.submitted && code?.invalid">
                    <div [hidden]="!code.errors.required" class="formError"> * Code is required</div>
                  </div>
                </div>
                <div class="form-group col-lg-12">  &nbsp;
                </div>
                  <div class="form-group col-lg-12">  &nbsp;
                </div>

              </div>
              <div class="col-md-6">
                <div class="form-group col-lg-12">
                  <label for="Qty" class="labelRequired">Qty </label>
                  <input type="number" placeholder="Quantity" class="form-control" name="quantity" #quantity="ngModel"
                         ngModel required [ngClass]="{'has-danger' :cat?.submitted  && quantity?.invalid }">
                  <div *ngIf="cat?.submitted  && quantity?.invalid">
                    <div [hidden]="!quantity.errors.required" class="formError"> * Quantity is required</div>
                  </div>
                </div>
                <div class="form-group col-lg-12">
                  <label for="Rate" class="labelRequired">Rate </label>
                  <input type="text" placeholder="Rate" class="form-control" name="rate" #rate="ngModel" ngModel
                         required [ngClass]="{'has-danger':cat?.submitted && rate?.invalid }">
                  <div *ngIf="cat?.submitted && rate?.invalid">
                    <div [hidden]="!rate.errors.required" class="formError"> *Rate is required</div>
                  </div>
                </div>
<!--
                <div class="form-group col-lg-12">
                  <label for="Discount Percentage">Discount Percentage </label>
                  <input type="text" placeholder="Discount Percentage" class="form-control" name="dis_percentage"
                         #dis_percentage="ngModel" ngModel formnovalidate>
                </div>
                <div class="form-group col-lg-12">
                  <label for="Discount">Discount </label>
                  <input type="text" placeholder="Discount" class="form-control" name="discount" #discount="ngModel"
                         ngModel formnovalidate>
                </div>
                <div class="form-group col-lg-12">
                  <label for="Amount" class="labelRequired">Amount </label>
                  <input type="text" placeholder="Amount" class="form-control" name="amount" #amount="ngModel" ngModel
                         required [ngClass]="{'has-danger':cat?.submitted && amount?.invalid }">
                  <div *ngIf="cat?.submitted && amount?.invalid">
                    <div [hidden]="!amount.errors.required" class="formError"> *Amount is required</div>
                  </div>
                </div>
-->

                <BR><BR><BR>
              </div>
            </div>
          </div>
        </div>
      </mat-dialog-content>
    </div>

    <div class="edit" *ngIf="editData">
      <div class="ModalHeader">
        <h4 mat-dialog-title>Edit Products</h4>
        <div class="headerButton">
          <button *ngIf="editPermission" type="submit" class="btn btn-success"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save
          </button>
          <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i
            class="fa fa-times" aria-hidden="true"></i> Cancel
          </button>
        </div>
      </div>

      <mat-dialog-content>
        <div class="card">
          <div class="card-body">
            <div class="form-group col-lg-12">
              <div class="col-md-6">
                <div class="form-group col-lg-12">
                  <label for="Body Part" class="labelRequired">Body Part </label>
                  <select id="mySelect" data-show-content="true" class="form-control" placeholder="Body Part"
                          [ngClass]="{'has-danger':cat?.submitted && body_part_id?.invalid }"
                          [(ngModel)]="model.body_part_id" name="body_part_id" (change)="bodypartChange($event)"
                          #body_part_id="ngModel" formnovalidate>
                    <option disabled>Select Body Part</option>
                    <option *ngFor="let data of bodypartsData" [value]="data?.id">
                      {{data?.name}}
                    </option>
                  </select>
                  <div *ngIf="cat?.submitted  && body_part_id?.invalid">
                    <div [hidden]="!body_part_id.errors.required" class="formError"> * Body Part is required</div>
                  </div>
                </div>

                <div class="form-group col-lg-12">
                  <label for="Implant" class="labelRequired">Implant </label>
                  <select id="mySelect" data-show-content="true" class="form-control" placeholder="Implant"
                          [ngClass]="{'has-danger':cat?.submitted && implant_id?.invalid }"
                          [(ngModel)]="model.implant_id" name="implant_id" (change)="implantChange($event)"
                          #implant_id="ngModel" formnovalidate>
                    <option disabled>Select Implant</option>
                    <option *ngFor="let data of implantsSelect" [value]="data?.id">
                      {{data?.name}}
                    </option>
                  </select>

                  <div *ngIf="cat?.submitted  && implant_id?.invalid">
                    <div [hidden]="!quantity.errors.required" class="formError"> * Implant Type is required</div>
                  </div>
                </div>

                <div class="form-group col-lg-12">
                  <label for="Product Category" class="labelRequired">Product Category </label>
                  <select id="mySelect" data-show-content="true" class="form-control" placeholder="Product Category"
                          [(ngModel)]="model.product_category_id" name="product_category_id" formnovalidate>
                    <option disabled>Select Product Category</option>
                    <option *ngFor="let data of productCategorySelect" [value]="data?.id">
                      {{data?.name}}
                    </option>
                  </select>
                </div>

                <div class="form-group col-lg-12">
                  <label for="Name" class="labelRequired">Name </label>
                  <input type="text" placeholder="Name" class="form-control" name="name" [(ngModel)]="editData.name"
                         required #name="ngModel" [ngClass]="{'has-danger':cat?.submitted && name?.invalid }">
                  <div *ngIf="cat?.submitted && name?.invalid">
                    <div [hidden]="!name.errors.required" class="formError"> *Product Name is required</div>
                  </div>
                </div>

                <div class="form-group col-lg-12">
                  <label for="Code" class="labelRequired">Code </label>
                  <input type="text" placeholder="Code" class="form-control" name="code" [(ngModel)]="editData.code"
                         required #code="ngModel" [ngClass]="{'has-danger':cat?.submitted && code?.invalid }">
                  <div *ngIf="cat?.submitted && code?.invalid">
                    <div [hidden]="!code.errors.required" class="formError"> *Code is required</div>
                  </div>

                </div>

                <div class="form-group col-lg-12"> &nbsp;
                </div>
                <div class="form-group col-lg-12"> &nbsp; 
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group col-lg-12">
                  <label for="Qty" class="labelRequired">Qty </label>
                  <input type="number" placeholder="Quantity" class="form-control" name="quantity"
                         [(ngModel)]="editData.quantity" required #quantity="ngModel"
                         [ngClass]="{'has-danger':cat?.submitted && quantity?.invalid }">
                  <div *ngIf="cat?.submitted && quantity?.invalid">
                    <div [hidden]="!quantity.errors.required" class="formError"> *Qty is required</div>
                  </div>
                </div>

                <div class="form-group col-lg-12">
                  <label for="Rate" class="labelRequired">Rate </label>
                  <input type="text" placeholder="Rate" class="form-control" name="rate" [(ngModel)]="editData.rate"
                         required [ngClass]="{'has-danger':cat?.submitted && rate?.invalid }" #rate="ngModel">
                  <div *ngIf="cat?.submitted && rate?.invalid">
                    <div [hidden]="!rate.errors.required" class="formError"> *Rate is required</div>
                  </div>
                </div>

                <div class="form-group col-lg-12">
                </div>

                <div class="form-group col-lg-12">
                </div>

                <div class="form-group col-lg-12">
                </div>

               <div class="header-logo">
               <img src="{{ImgName}}" style="">
               </div>


              </div>

            </div>
          </div>
        </div>
      </mat-dialog-content>
    </div>

  </form>
</div>
